import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=909d83a2&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('909d83a2')) {
      api.createRecord('909d83a2', component.options)
    } else {
      api.reload('909d83a2', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=909d83a2&", function () {
      api.rerender('909d83a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ZzvH23a4DZkG/JS/offershelp.vue"
export default component.exports